// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1--Tv","OrderButton":"BuildControls_OrderButton__3-Uun","enable":"BuildControls_enable___Qr5k"};